import React, { Component } from 'react';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import { sharedConstants } from 'shared-helpers';

// constants
import { CONTACT_FORM_TYPE, TAXONOMIES, TELEPHONE_REGEX } from '../../lib/constants';

// helpers
import { isValidCompanyEmail, isValidEmail, withBootstrapPlugin } from '/src/lib/helpers';
import AmplitudeHelperClass from '../../lib/amplitudeHelper';

//apis
import taxonomyApi from '../../apis/taxonomyApi';
import contactSalesApi from '../../apis/contactSalesApi';

// styles
const reactSelectSmall = sharedConstants.reactSelectSmall;
const reactSelectTheme = sharedConstants.reactSelectTheme;

const amplitudeHelper = new AmplitudeHelperClass();

export default class ContactForm extends Component {

    constructor() {
        super();
        this.state = {
            first_name: '',
            last_name: '',
            email: '',
            position: '',
            company_name: '',
            companyType: '',
            phone_number: '',
            country_code: '',
            reason: '',

            // options
            reasons: [],
            companyTypes: [],

            error: '',
            isFieldEmpty: false,
            isSubmitting: false,
        }
        this.isComponentMounted = false;
    }

    componentDidMount() {
        this.isComponentMounted = true;
        const { taxonomyType } = this.props;

        taxonomyApi.getTaxonomyType(taxonomyType).then(
            response => {
                if (!response?.length) return;

                const reasons = response.map(reason => {
                    return { value: reason.id, label: reason.name };
                });

                this.updateState({ reasons });
            }
        )

        // Get Company type options
        taxonomyApi.getTaxonomyType(TAXONOMIES.companyType).then(
            response => {
                if (!response?.length) return;

                const companyTypes = response.map(type => {
                    return { value: type.id, label: type.name };
                });

                this.updateState({ companyTypes });
            }
        )
    }

    componentWillUnmount() {
        this.isComponentMounted = false;
    }

    updateState = (state, callback) => {
        if (this.isComponentMounted) {
            this.setState(state, callback);
        }
    }

    handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        let obj = {};
        obj[name] = value;

        this.updateState(obj);
    }

    handlePhoneChange = (phoneNumber, country) => {
        this.updateState({ phone_number: phoneNumber, country_code: country.countryCode });
    }

    handleSelectChange = (field, option) => {
        this.updateState({
            [field]: option
        });
    }

    handleEmailValidation = email => {
        if (!isValidEmail(email)) {
            return 'Please enter a valid email address';
        } else if (!isValidCompanyEmail(email)) {
            return 'Please enter a company email address instead of a personal one';
        }
        return false
    }

    handleValidate = async () => {
        if (this.state.isSubmitting) {
            return;
        }

        const { first_name, last_name, email, position, company_name, reason, companyType, phone_number, country_code } = this.state;

        const missingFields = (first_name === '' || last_name === '' || email === '' || position === '' || company_name === '' || reason === '' || companyType === '');
        const invalidEmailMessage = this.handleEmailValidation(email.toLowerCase())

        let invalidPhoneNumber = false;
        if (phone_number && country_code) {
            const phRegex = TELEPHONE_REGEX[country_code];
            if (phRegex && !phRegex.test(phone_number)) {
                invalidPhoneNumber = true;
            }
        }

        if (missingFields) {
            this.updateState({ error: "Please fill in all the required fields", isFieldEmpty: true });
        } else if (invalidEmailMessage) {
            this.updateState({ error: invalidEmailMessage })
        } else if (invalidPhoneNumber) {
            this.updateState({ error: "Please enter valid phone number for the country selected"});
        } else {
            this.updateState({ error: '', isFieldEmpty: false });
            await this.handleSubmit();
        }
    }

    amplitudeTrackEvent = () => {
        let event = "";

        if (this.props.page) {
            event = `Form submitted from ${this.props.page} page`;
        } else {
            let page = "";
            switch (this.props.formType) {
            case CONTACT_FORM_TYPE.marketing:
                page = "Marketing";
                break;
            case CONTACT_FORM_TYPE.demo_request:
                page = "Demo Request";
                break;
            case CONTACT_FORM_TYPE.enterprise:
                page = "Enterprise";
                break;
            case CONTACT_FORM_TYPE.bespoke_report:
                page = "Bespoke Report";
                break
            default:
                break;
            }

            event = `Form submitted from ${page} page`;
        }

        amplitudeHelper.trackEvent(event);
    }

    /* track a amplitude event when user types in a field */
    trackFieldEntered = (name) => {
        amplitudeHelper.trackEvent('Typed in Form Field', {
            field_entered: name
        });
    }

    handleSubmit = async () => {
        this.updateState({ isSubmitting: true });
        const { page } = this.props;
        const { first_name, last_name, email, position, company_name, phone_number, country_code, reason, companyType } = this.state;
        let utmSource, utmMedium, utmCampaign;

        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);

            utmSource = params.get('utm_source');
            utmMedium = params.get('utm_medium');
            utmCampaign = params.get('utm_campaign');
        }

        const payload = {
            first_name,
            last_name,
            email,
            position,
            company_name,
            company_type_id: companyType.value,
            phone_number,
            country_code,
            reason_id: reason.value,
            type: this.props.formType,
            page,
            path: window.location.pathname,
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign
        };

        contactSalesApi.post(payload).then(
            response => {
                this.updateState({
                    isSubmitting: false,
                    error: '',
                    isFieldEmpty: false,
                    first_name: '',
                    last_name: '',
                    email: '',
                    position: '',
                    company_name: '',
                    phone_number: '',
                    reason: '',
                    companyType: ''
                });

                // close the form popup
                if (this.props.popup) {
                    withBootstrapPlugin('modal', ($) => $('.modal').modal('hide'));
                }

                this.showSuccessPopup();
                this.amplitudeTrackEvent();
            }
        ).catch(error => {
            if (error?.response?.data?.errors[0]?.path === "email") {
                const { message } = error.response.data.errors[0];
                return this.updateState({
                    error: message,
                    isSubmitting: false
                });

            }
            this.updateState({
                error: 'There was an error submitting the form, please reload the page and try again.',
                isSubmitting: false
            });
        });
    }

    showSuccessPopup = () => {
        withBootstrapPlugin('modal', ($) => $('#successModal').modal({
            backdrop: 'static',
            keyboard: true,
            show: true
        }));
    }

    render() {

        const { first_name, last_name, email, position, company_name, phone_number, reason, reasons, companyType, companyTypes, isFieldEmpty } = this.state;
        const { page, popup, headerText } = this.props;

        let columnStyle = "";
        if (!popup) {
            columnStyle = "col-md-10 col-lg-5 col-xl-5 mx-auto";
        }

        const col_half = "col-12 col-md-6";
        const col_full = "col-12";
        const isEnterpriseForm = ((page === "enterprise") && !popup);

        const INDICATOR_STYLE = {
            marginTop: -27
        }

        return (
            <div className={`contact-form-box ${columnStyle}`}>
                <div className="db-box no-background h-100">
                    <div className="contact-form">

                        {headerText ? <h6>{headerText}</h6> : ""}

                        <div className="row">

                            <div className={col_half}>
                                <input
                                    className={isFieldEmpty && !first_name ? "error" : ""}
                                    placeholder="First Name"
                                    name="first_name"
                                    type="text"
                                    value={first_name}
                                    onChange={this.handleChange}
                                    onBlur={() => this.trackFieldEntered("first_name")}
                                />
                            </div>

                            <div className={col_half}>
                                <input
                                    className={isFieldEmpty && !last_name ? "error" : ""}
                                    placeholder="Last Name"
                                    name="last_name"
                                    type="text"
                                    value={last_name}
                                    onChange={this.handleChange}
                                    onBlur={() => this.trackFieldEntered("last_name")}
                                />
                            </div>

                            <div className={isEnterpriseForm ? col_half : col_full}>
                                <input
                                    className={isFieldEmpty && !email ? "error" : ""}
                                    placeholder="Email"
                                    name="email"
                                    type="text"
                                    value={email}
                                    onChange={this.handleChange}
                                    onBlur={() => this.trackFieldEntered("email")}
                                />
                            </div>

                            <div className={isEnterpriseForm ? col_half : col_full}>
                                <input
                                    className={isFieldEmpty && !company_name ? "error" : ""}
                                    placeholder="Company Name"
                                    name="company_name"
                                    type="text"
                                    value={company_name}
                                    onChange={this.handleChange}
                                    onBlur={() => this.trackFieldEntered("company_name")}
                                />
                            </div>

                            <div className={col_full}>
                                <Select
                                    instanceId="contact-form-company-type"
                                    className={`contact-form-react-select ${isFieldEmpty && !companyType ? "error" : ""}`}
                                    placeholder="Company Type"
                                    theme={reactSelectTheme}
                                    styles={{
                                        ...reactSelectSmall,
                                        control: (provided, state) => ({
                                            ...provided,
                                            height: 30,
                                            borderColor: "#eee",
                                            boxShadow: "none",
                                            fontSize: 14,
                                            '&:hover': {
                                                borderColor: "#eee",
                                            }
                                        }),
                                        indicatorsContainer: (provided, state) => (INDICATOR_STYLE),
                                    }}
                                    options={companyTypes}
                                    value={companyType}
                                    onChange={(e) => this.handleSelectChange('companyType', e)}
                                    onBlur={() => this.trackFieldEntered("company_type")}
                                />
                            </div>

                            <div className={isEnterpriseForm ? col_half : col_full}>
                                <input
                                    className={isFieldEmpty && !position ? "error" : ""}
                                    placeholder="Position"
                                    name="position"
                                    type="text"
                                    value={position}
                                    onChange={this.handleChange}
                                    onBlur={() => this.trackFieldEntered("position")}
                                />
                            </div>

                            <div className={isEnterpriseForm ? col_half : col_full}>
                                <PhoneInput
                                    inputStyle={{ paddingLeft: '45px !important' }}
                                    containerStyle={{ marginBottom: 12 }}
                                    country={'ae'}
                                    placeholder={'+971 555 123 876'}
                                    value={phone_number}
                                    onChange={(value, country) => this.handlePhoneChange(value, country)}
                                    onBlur={() => this.trackFieldEntered("phone_number")}
                                />
                            </div>

                            <div className={col_full}>
                                <Select
                                    instanceId="contact-form-reason"
                                    className={isFieldEmpty && !reason ? "error" : ""}
                                    placeholder="What are you looking for?"
                                    theme={reactSelectTheme}
                                    styles={{
                                        ...reactSelectSmall,
                                        control: (provided, state) => ({
                                            ...provided,
                                            height: 30,
                                            borderColor: "#eee",
                                            boxShadow: "none",
                                            fontSize: 14,
                                            '&:hover': {
                                                borderColor: "#eee",
                                            }
                                        }),
                                        indicatorsContainer: (provided, state) => (INDICATOR_STYLE),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 400,
                                        }),
                                    }}
                                    options={reasons}
                                    value={reason}
                                    onChange={(e) => this.handleSelectChange('reason', e)}
                                    onBlur={() => this.trackFieldEntered("reason")}
                                />
                            </div>

                            <div className="col-12 col-md-12 contact-btn-box">
                                {this.state.error !== '' ?
                                    <p className="error-feedback">{this.state.error}</p> : ''
                                }

                                <a tabIndex={1} className="btn btn-main btn-block" onClick={this.handleValidate}>
                                    {this.state.isSubmitting &&
                                        <i className="fas fa-circle-notch fa-spin mr-2"></i>
                                    }
                                    {this.state.isSubmitting ? 'Submitting' : this.props.buttonLabel || 'Contact Sales'}
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

